import { useGetOne, useTranslate, type Identifier } from "ra-core";
import { Link } from "react-router";

import { Avatar } from "../contacts/Avatar";
import type { Contact } from "../types";

// The contact a task is about, under the task text and beside "from <meeting>".
// A link, not an assignment: the assignee is the pill on the right. Hidden on
// the Contact page's own section, where every row would point at the open page.
// LCATOMICZO-31.
export const TaskContactLink = ({
  contactId,
}: {
  contactId?: Identifier | null;
}) => {
  const translate = useTranslate();
  const { data: contact } = useGetOne<Contact>(
    "contacts",
    { id: contactId! },
    { enabled: contactId != null },
  );

  if (contactId == null || !contact) return null;

  return (
    <Link
      to={`/contacts/${contactId}/show`}
      // The mobile row taps to complete, so a tap on the link must not tick it.
      onClick={(event) => event.stopPropagation()}
      className="group flex items-center gap-1.5 mt-1 text-xs text-foreground w-fit"
    >
      {/* Bill read the old line, small grey text beside a person icon, as a
          caption and never clicked it. The face and the underline say "this
          opens the person". Hidden from assistive tech so the initials do not
          become part of the link's name. LCCRM-86. */}
      <span aria-hidden="true" className="flex shrink-0">
        <Avatar record={contact} width={20} height={20} />
      </span>
      <span className="underline underline-offset-2 decoration-muted-foreground/60 group-hover:decoration-foreground">
        {translate("resources.tasks.contact_line", {
          name: `${contact.first_name} ${contact.last_name}`.trim(),
        })}
      </span>
    </Link>
  );
};
